import { gql_request, GqlRequestOptions } from '@common/api-request';

import * as types from './pdp_recommend_id_list_types.2';

export function getPdpRecommendIdList(variable: types.GetPdpRecommendIdListVariables, options?: GqlRequestOptions) {
  const query = 'query GetPdpRecommendIdList($catalog_product_id: ID!) { pdp_recommend_id_list(catalog_product_id: $catalog_product_id) { key attribute_value { id dr_log } } }';
  return gql_request<types.GetPdpRecommendIdList, types.GetPdpRecommendIdListVariables>('GetPdpRecommendIdList', query, variable, { use_consumer: true, ...options });
}

